
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useApp } from '@/contexts/AppContext';
import { LogOut, User, History, DollarSign } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const Header: React.FC = () => {
  const { currentUser, logout } = useApp();
  const isMobile = useIsMobile();
  
  // Obter informações da empresa do localStorage
  const empresaNome = localStorage.getItem('empresa_nome') || 'RSP Cloud App';
  
  // Determinar se o usuário pode ver histórico e caixa
  const isAdmin = currentUser?.role === 'admin';
  const isManager = currentUser?.isManager === true;
  const showHistoryAndCashier = (isAdmin || isManager || currentUser?.role === 'waiter');
  
  return (
    <header className="bg-primary text-primary-foreground py-4">
      <div className="container flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Link to="/" className="text-xl font-bold">
            {empresaNome}
          </Link>
        </div>
        
        {currentUser && !isMobile && (
          <div className="flex items-center gap-4">
            {showHistoryAndCashier && (
              <>
                <Link to="/completed-tables">
                  <Button variant="ghost" size="sm" className="text-primary-foreground">
                    <History className="mr-1 h-4 w-4" />
                    Histórico
                  </Button>
                </Link>
                <Link to="/cashier-closing">
                  <Button variant="ghost" size="sm" className="text-primary-foreground">
                    <DollarSign className="mr-1 h-4 w-4" />
                    Caixa
                  </Button>
                </Link>
              </>
            )}
            <div className="flex items-center gap-2">
              <User className="h-4 w-4" />
              <span>{currentUser.name}</span>
            </div>
            <Button variant="outline" size="sm" onClick={logout} className="flex items-center gap-1 bg-red-600 hover:bg-red-700 text-white border-transparent">
              <LogOut className="h-4 w-4" />
              <span>Sair</span>
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
